import client from './client';

export const list = (params) =>
  client.get('/api/kb', { params }).then(r => r.data);

export const get = (id) =>
  client.get(`/api/kb/${id}`).then(r => r.data);

export const create = (body) =>
  client.post('/api/kb', body).then(r => r.data);

export const update = (id, body) =>
  client.patch(`/api/kb/${id}`, body).then(r => r.data);

export const archive = (id) =>
  client.post(`/api/kb/${id}/archive`).then(r => r.data);

export const unarchive = (id) =>
  client.post(`/api/kb/${id}/unarchive`).then(r => r.data);
